import { Plus, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AddEntryButtonsProps {
  onAddLearning: () => void;
  onAddDocument: () => void;
}

export function AddEntryButtons({ onAddLearning, onAddDocument }: AddEntryButtonsProps) {
  return (
    <>
      <Button variant="outline" size="sm" className="gap-1.5" onClick={onAddLearning}>
        <Plus className="h-4 w-4" />
        Add Learning
      </Button>
      <Button size="sm" className="gap-1.5" onClick={onAddDocument}>
        <Upload className="h-4 w-4" />
        Upload Document
      </Button>
    </>
  );
}
